var blockquote_default = {
  "fontElementMap": "ulhV6",
  "quote": "CR1YZ"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
